import { Http, RequestOptions, Headers } from '@angular/http';
import { Component } from '@angular/core';
import { NavController, LoadingController, PopoverController, NavParams, ModalController, ToastController, AlertController, MenuController, App, IonicPage } from 'ionic-angular';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { ViewContactPage } from '../view-contact/view-contact';
import { LoadingProvider } from '../../providers/loading/loading';
import { EditPopoverPage } from '../edit-popover/edit-popover';
import { ChangeAssignedBrokerPage } from '../change-assigned-broker/change-assigned-broker';
import { AttachmentRequestsPage } from '../attachment-requests/attachment-requests';
import { StepformPage } from '../stepform/stepform';
import { ChangeLogProfilePage } from '../change-log-profile/change-log-profile';
import { TentativeRealEstateAssetPage } from '../tentative-real-estate-asset/tentative-real-estate-asset';
import { ChangeContactTypePopupPage } from '../change-contact-type-popup/change-contact-type-popup';
import { AngularFireAuth } from 'angularfire2/auth';
import { HomeService } from '../../app/services/home-service';
import RealEstatePage from '../real-estate/real-estate';
import {EnvDataService} from '../../app/services/env-data-service';
import { AdfPage } from '../adf-page/adf-page';
import {ContactFormService} from '../edit-contact-form-list/services/contact-form.service';
import {AdfListService} from '../adf-page/services/adf-list.service';
import { ContactList } from '../contact-list/contact_list';
import { ShowContactForm } from '../show-contact/show-contact';
import {ViewAdfPage} from '../view-adf/view-adf';
import {AdfList} from '../adf-list/adf-list';

/**
 * Generated class for the AdminDashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-admin-dashboard',
  templateUrl: 'admin-dashboard.html',
  providers:[EnvDataService,ContactFormService,AdfListService]
})
export class AdminDashboardPage {

  public email: any;
  public uid: any;
  public count: any;
  public secondary_uid: any;
  public firstname: any;
  public lastname: any;
  public getRole: any;
  public usersList : any = [];
  data: any;
  public loading: any;
  public contactTotal: number;
  public innerJoinDocument: any;
  public deleted_access: any;
  public mercuryIncome: any;
  public mercuryAssets: any;
  public mercuryLiabilities: any;
  public mercuryRealEstate: any;
  public limit: number;
  public allTotalContact: number;
  public contactTtype: number;
  public contactTmore: number;
  public assets_data: any;
  public liabilities_data: any;
  public realEstate_data: any;
  public second_contact_data: any;
  public second_employment_data: any;
  public second_income_data: any;
  public second_asset_data: any;
  public second_liabilities_data: any;
  public userData: any;
  public haveClickedview: any;
  public haveRecord: any;
  public totalContacts:any;
  public totalAdfs:any;
  public AllOpenAdfs:any;
  public AllCloseAdfs:any;
  public loadingstate = 1;
  public contactkey:boolean = false;
  public allcontactlist:any = [];
  public alldflist:any = [];
  public contactdata:any = [];
  public adfdata:any = [];
  public adfkey:boolean =false;
  public rootPage:any;
  constructor(
    public navCtrl: NavController,
    public db: AngularFirestore,
    public loadingProvider: LoadingProvider,
    public loadingCtrl: LoadingController,
    public popoverCtrl: PopoverController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public afAuth: AngularFireAuth,
    public http: Http,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController,
    public menuCtrl: MenuController,
    public HomeService: HomeService,
    public app: App,
    private EnvDataService:EnvDataService,
    private ContactFormService:ContactFormService,
    public afdService:AdfListService,
  )
  {


    db.collection('users').doc('null').delete();

    window.localStorage.removeItem("contact_uid");
    window.localStorage.removeItem("contact_second_uid");
    window.localStorage.removeItem("edit_contact_uid");
    window.localStorage.removeItem("total_assets");
    window.localStorage.removeItem("total_income");
    window.localStorage.removeItem("total_liabilities");
    window.localStorage.removeItem("total_realestate");
    window.localStorage.removeItem("deleted_access");
    window.localStorage.removeItem("generate_new_tentative");
    window.localStorage.removeItem("creating_second");
    window.localStorage.removeItem('SDF_form_document_id');

    let thiss = this;
    this.email = window.localStorage.getItem("email");
    this.uid = window.localStorage.getItem("uid");
    this.limit = 20;
    this.allTotalContact = 0;
    this.contactTmore = 1;
    this.userData = [];
    this.rootPage = 'AdminDashboardPage';
    // generate keyword

    //this.generatekeyword();
    //this.testuserkeyword();
    //this.searchuser();
     //this.generateAdfkeyword();
    /* get all contacts*/
     thiss.presentLoadingText();
    //  this.getAllcontacts()
    //  this.getAllAdflist()
    // // this.getAllOpenAdf();
    // // this.getAllCloseform();
    // /* Dashboard Functions*/

    thiss.getDashboardData();
   // thiss.gekeywordsemptyData();

    // if(this.loadingstate =4) {
    //   thiss.loading.dismiss();
    // }
    /*get all contacts*/
    // firebase.firestore().collection("SDF_form").get()
    // .then(function(querySnapshotSDF) {
    //   console.log('querySnapshotSDF.size', querySnapshotSDF.size);
    // })
    // firebase.firestore().collection("users").where("roles.contact", "==", true).where("contact_type", "==", "Primary Contact").get()
    // .then(function(querySnapshot) {
    //   console.log('querySnapshot.size', querySnapshot.size);
    //   let timestamp;
    //   const docRef = firebase.firestore().collection('/SDF_form');
    //   const docRef1 = firebase.firestore().collection('/users_data');
    //   const docRef2 = firebase.firestore().collection('/employment');
    //   const docRef3 = firebase.firestore().collection('/SDF_income');
    //   const docRef4 = firebase.firestore().collection('/SDF_assets');
    //   const docRef5 = firebase.firestore().collection('/SDF_liabilities');
    //   const docRef6 = firebase.firestore().collection('/SDF_realestate');
    //   querySnapshot.forEach(function(doc) {
    //     if(doc.data().uid != ''){
    //       firebase.firestore().collection("SDF_form").where("uid", "==", doc.data().uid).get()
    //       .then(function(querySnapshot1) {
    //         if(querySnapshot1.empty){
    //           if(doc.data().contact_type == 'Primary Contact'){
    //             timestamp = new Date().getTime();
    //             docRef.doc(doc.data().uid+'_'+timestamp).set({
    //               id : doc.data().uid+'_'+timestamp,
    //               uid : doc.data().uid
    //             });
    //           }
    //         }else{
    //           querySnapshot1.forEach(function(doc1) {
    //             timestamp = new Date().getTime();
    //             docRef1.doc(doc1.data().id).set(doc.data())
    //             .then(function(res) {
    //               docRef1.doc(doc1.data().id).update({
    //                 SDF_form_document_id : doc1.data().id,
    //                 document_id : doc1.data().id,
    //                 previousAddress: []
    //               });

    //               firebase.firestore().collection("employment").where("uid", "==", doc.data().uid).get()
    //               .then(function(querySnapshot2) {
    //                 querySnapshot2.forEach(function(doc2) {
    //                   if(doc2.data().document_id == undefined || doc2.data().document_id == null || doc2.data().document_id == ""){
    //                     docRef2.doc(doc2.data().uid).update({
    //                       SDF_form : doc1.data().id,
    //                       document_id: doc2.data().uid
    //                     });
    //                   }else{
    //                     docRef2.doc(doc2.data().document_id).update({
    //                       SDF_form : doc1.data().id
    //                     });
    //                   }
    //                 });
    //               })

    //               firebase.firestore().collection("SDF_income").where("uid", "==", doc.data().uid).get()
    //               .then(function(querySnapshot3) {
    //                 querySnapshot3.forEach(function(doc3) {
    //                   if(doc3.data().document_id == undefined || doc3.data().document_id == null || doc3.data().document_id == ""){
    //                     docRef3.doc(doc3.data().uid).update({
    //                       SDF_form : doc1.data().id,
    //                       document_id: doc3.data().uid
    //                     });
    //                   }else{
    //                     docRef3.doc(doc3.data().document_id).update({
    //                       SDF_form : doc1.data().id
    //                     });
    //                   }
    //                 });
    //               })

    //               firebase.firestore().collection("SDF_assets").where("uid", "==", doc.data().uid).get()
    //               .then(function(querySnapshot4) {
    //                 querySnapshot4.forEach(function(doc4) {
    //                   if(doc4.data().document_id == undefined || doc4.data().document_id == null || doc4.data().document_id == ""){
    //                     docRef4.doc(doc4.data().uid).update({
    //                       SDF_form : doc1.data().id,
    //                       document_id: doc4.data().uid,
    //                       percentage_asset_0: "",
    //                       percentage_asset_1: "",
    //                       percentage_asset_2: "",
    //                       percentage_asset_3: "",
    //                       percentage_asset_4: "",
    //                     });
    //                   }else{
    //                     docRef4.doc(doc4.data().document_id).update({
    //                       SDF_form : doc1.data().id,
    //                       percentage_asset_0: "",
    //                       percentage_asset_1: "",
    //                       percentage_asset_2: "",
    //                       percentage_asset_3: "",
    //                       percentage_asset_4: "",
    //                     });
    //                   }
    //                 });
    //               })

    //               firebase.firestore().collection("SDF_liabilities").where("uid", "==", doc.data().uid).get()
    //               .then(function(querySnapshot5) {
    //                 querySnapshot5.forEach(function(doc5) {
    //                   if(doc5.data().document_id == undefined || doc5.data().document_id == null || doc5.data().document_id == ""){
    //                     docRef5.doc(doc5.data().uid).update({
    //                       SDF_form : doc1.data().id,
    //                       document_id: doc5.data().uid
    //                     });
    //                   }else{
    //                     docRef5.doc(doc5.data().document_id).update({
    //                       SDF_form : doc1.data().id
    //                     });
    //                   }
    //                 });
    //               })

    //               firebase.firestore().collection("SDF_realestate").where("primary_uid", "==", doc.data().uid).get()
    //               .then(function(querySnapshot6) {
    //                 querySnapshot6.forEach(function(doc6) {
    //                   if(doc6.data().document_id == undefined || doc6.data().document_id == null || doc6.data().document_id == ""){
    //                     docRef6.doc(doc6.data().uid).update({
    //                       SDF_form : doc1.data().id,
    //                       document_id: doc6.data().uid,
    //                       secondary_percentage_asset_0: "",
    //                       secondary_percentage_asset_1: "",
    //                       secondary_percentage_asset_2: "",
    //                       secondary_percentage_asset_3: "",
    //                       secondary_percentage_asset_4: "",
    //                     });
    //                   }else{
    //                     docRef6.doc(doc6.data().document_id).update({
    //                       SDF_form : doc1.data().id,
    //                       secondary_percentage_asset_0: "",
    //                       secondary_percentage_asset_1: "",
    //                       secondary_percentage_asset_2: "",
    //                       secondary_percentage_asset_3: "",
    //                       secondary_percentage_asset_4: "",
    //                     });
    //                   }
    //                 });
    //               })

    //             })
    //             .catch(function(error) {
    //               console.log("Error getting documents: ", error);
    //             });
    //           });
    //         }
    //       });
    //     }
    //   });
    // })
    // .catch(function(error) {
    //     console.log("Error getting documents: ", error);
    // });

    // firebase.firestore().collection("users_data").get()
    // .then(function(querySnapshotUsersdata) {
    //   console.log('querySnapshot.size', querySnapshotUsersdata.size);
    // })

    // firebase.firestore().collection("users").where("roles.contact", "==", true).where("contact_type", "==", "Secondary Contact").get()
    // .then(function(querySnapshot) {
    //   console.log('querySnapshot.size', querySnapshot.size);
    //   const docRef = firebase.firestore().collection('/SDF_form');
    //   const docRef1 = firebase.firestore().collection('/users_data');
    //   const docRef2 = firebase.firestore().collection('/employment');
    //   const docRef3 = firebase.firestore().collection('/SDF_income');
    //   const docRef4 = firebase.firestore().collection('/SDF_assets');
    //   const docRef5 = firebase.firestore().collection('/SDF_liabilities');
    //   const docRef6 = firebase.firestore().collection('/SDF_realestate');
    //   querySnapshot.forEach(function(doc) {
    //     if(doc.data().uid != ''){
    //       let timestamp;
    //       if(doc.data().contact_type == 'Secondary Contact'){
    //         if(doc.data().main_contact_uid == "" || doc.data().main_contact_uid == null || doc.data().main_contact_uid == undefined){}else{
    //           firebase.firestore().collection("SDF_form").where("uid", "==", doc.data().main_contact_uid).get()
    //           .then(function(querySnapshot) {
    //             querySnapshot.forEach(function(doc1) {
    //               timestamp = new Date().getTime();
    //               let doc_idd = doc.data().uid+'_'+timestamp;
    //               console.log('doc.data().uid', doc.data().uid),
    //               console.log('doc1.data().id', doc1.data().id),
    //               firebase.firestore().collection("users_data").where("uid", "==", doc.data().uid).where("SDF_form", "==", doc1.data().id).get()
    //               .then(function(querySnapshot1) {
    //                 querySnapshot1.forEach(function(doc2) {
    //                   console.log('test1');
    //                   docRef1.doc(doc2.data().document_id).update(doc.data())
    //                   .then(function(res) {
    //                     docRef1.doc(doc2.data().documents).update({
    //                       SDF_form_document_id : doc1.data().id,
    //                       primary_uid : (doc.data().main_contact_uid != undefined) ? doc.data().main_contact_uid : '',
    //                       previousAddress: []
    //                     });
    //                   })
    //                 })
    //                 if(querySnapshot1.empty){
    //                   console.log('test2');
    //                   docRef1.doc(doc_idd).set(doc.data())
    //                   .then(function(res) {
    //                     docRef1.doc(doc_idd).update({
    //                       SDF_form_document_id : doc1.data().id,
    //                       document_id : doc_idd,
    //                       primary_uid : (doc.data().main_contact_uid != undefined) ? doc.data().main_contact_uid : '',
    //                       previousAddress: []
    //                     });
    //                   })
    //                 }


    //                 firebase.firestore().collection("employment").where("uid", "==", doc.data().uid).get()
    //                 .then(function(querySnapshot2) {
    //                   querySnapshot2.forEach(function(doc2) {
    //                     if(doc2.data().document_id == undefined || doc2.data().document_id == null || doc2.data().document_id == ""){
    //                       docRef2.doc(doc2.data().uid).update({
    //                         SDF_form : doc1.data().id,
    //                         document_id: doc2.data().uid
    //                       });
    //                     }else{
    //                       docRef2.doc(doc2.data().document_id).update({
    //                         SDF_form : doc1.data().id
    //                       });
    //                     }
    //                   });
    //                 })

    //                 firebase.firestore().collection("SDF_income").where("uid", "==", doc.data().uid).get()
    //                 .then(function(querySnapshot3) {
    //                   querySnapshot3.forEach(function(doc3) {
    //                     if(doc3.data().document_id == undefined || doc3.data().document_id == null || doc3.data().document_id == ""){
    //                       docRef3.doc(doc3.data().uid).update({
    //                         SDF_form : doc1.data().id,
    //                         document_id: doc3.data().uid
    //                       });
    //                     }else{
    //                       docRef3.doc(doc3.data().document_id).update({
    //                         SDF_form : doc1.data().id
    //                       });
    //                     }
    //                   });
    //                 })

    //                 firebase.firestore().collection("SDF_assets").where("uid", "==", doc.data().uid).get()
    //                 .then(function(querySnapshot4) {
    //                   querySnapshot4.forEach(function(doc4) {
    //                     if(doc4.data().document_id == undefined || doc4.data().document_id == null || doc4.data().document_id == ""){
    //                       docRef4.doc(doc4.data().uid).update({
    //                         SDF_form : doc1.data().id,
    //                         document_id: doc4.data().uid,
    //                         percentage_asset_0: "",
    //                         percentage_asset_1: "",
    //                         percentage_asset_2: "",
    //                         percentage_asset_3: "",
    //                         percentage_asset_4: "",
    //                       });
    //                     }else{
    //                       docRef4.doc(doc4.data().document_id).update({
    //                         SDF_form : doc1.data().id,
    //                         percentage_asset_0: "",
    //                         percentage_asset_1: "",
    //                         percentage_asset_2: "",
    //                         percentage_asset_3: "",
    //                         percentage_asset_4: "",
    //                       });
    //                     }
    //                   });
    //                 })

    //                 firebase.firestore().collection("SDF_liabilities").where("uid", "==", doc.data().uid).get()
    //                 .then(function(querySnapshot5) {
    //                   querySnapshot5.forEach(function(doc5) {
    //                     if(doc5.data().document_id == undefined || doc5.data().document_id == null || doc5.data().document_id == ""){
    //                       docRef5.doc(doc5.data().uid).update({
    //                         SDF_form : doc1.data().id,
    //                         document_id: doc5.data().uid
    //                       });
    //                     }else{
    //                       docRef5.doc(doc5.data().document_id).update({
    //                         SDF_form : doc1.data().id
    //                       });
    //                     }
    //                   });
    //                 })

    //                 firebase.firestore().collection("SDF_realestate").where("primary_uid", "==", doc.data().uid).get()
    //                 .then(function(querySnapshot6) {
    //                   querySnapshot6.forEach(function(doc6) {
    //                     if(doc6.data().document_id == undefined || doc6.data().document_id == null || doc6.data().document_id == ""){
    //                       docRef6.doc(doc6.data().uid).update({
    //                         SDF_form : doc1.data().id,
    //                         document_id: doc6.data().uid,
    //                         secondary_percentage_asset_0: "",
    //                         secondary_percentage_asset_1: "",
    //                         secondary_percentage_asset_2: "",
    //                         secondary_percentage_asset_3: "",
    //                         secondary_percentage_asset_4: "",
    //                       });
    //                     }else{
    //                       docRef6.doc(doc6.data().document_id).update({
    //                         SDF_form : doc1.data().id,
    //                         secondary_percentage_asset_0: "",
    //                         secondary_percentage_asset_1: "",
    //                         secondary_percentage_asset_2: "",
    //                         secondary_percentage_asset_3: "",
    //                         secondary_percentage_asset_4: "",
    //                       });
    //                     }
    //                   });
    //                 })
    //               })
    //               .catch(function(error) {
    //                 console.log("Error getting documents: ", error);
    //               });
    //             });
    //           });
    //         }
    //       }
    //     }
    //   });
    // });




    console.log(this.uid);
    this.afAuth.authState.subscribe(data => {
      console.log('A informacao de data ', data);
      //thiss.loading.dismiss();
      if(data) {
        return data.uid;
      }

    });


    // var docRef = firebase.firestore().collection("users").doc(this.uid);
    // docRef.get().then(function(doc) {
    //     if (doc.exists) {
    //       thiss.presentLoadingText();
    //       let user_data = doc.data();
    //       thiss.firstname = user_data.firstname;
    //       thiss.lastname = user_data.lastname;
    //       if(user_data.roles.super_admin){
    //         thiss.contactTtype = 6;
    //         thiss.getRole = 'super_admin';
    //         thiss.deleted_access = user_data.deleted_access;
    //         window.localStorage.setItem("deleted_access", user_data.deleted_access);
    //       }else if(user_data.roles.broker){
    //         thiss.contactTtype = 5;
    //         thiss.getRole = 'broker';
    //       }else if(user_data.roles.loan_admin){
    //         thiss.contactTtype = 6;
    //         thiss.getRole = 'loan_admin';
    //       }else{
    //         thiss.getRole = 'contact';
    //       }
    //       window.localStorage.setItem("userRole", thiss.getRole);
    //       if(thiss.getRole == 'loan_admin'){
    //         thiss.data = [];
    //         thiss.contactTotal = 0;
    //         for(let j = 0; j < user_data.assigned_broker.length; j++){
    //           thiss.getAllPostss(user_data.assigned_broker[j]).subscribe((data)=>{
    //             for(let i = 0; i < data.length; i++) {
    //               data[i].user_data = [];
    //               data[i].total_Record = 0;
    //               data[i].icon = 'ios-arrow-down-outline';
    //               if(data[i].reference_broker == "" || data[i].reference_broker == null || data[i].reference_broker == undefined){}else{
    //                 var docRef1 = firebase.firestore().collection("users").doc(data[i].reference_broker);
    //                 docRef1.get().then(function(doc) {
    //                   if (doc.exists) {
    //                     data[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
    //                   }
    //                 }).catch(function(error) {
    //                   console.log("Error getting document:", error);
    //                 });
    //               }
    //             }
    //             thiss.loading.dismiss();
    //             thiss.data = thiss.data.concat(data);
    //             thiss.contactTotal += data.length;
    //           });
    //         }
    //       }else{
    //         thiss.getAllPosts().subscribe((data)=>{
    //           for(let i = 0; i < data.length; i++) {
    //             data[i].user_data = [];
    //             data[i].total_Record = 0;
    //             data[i].icon = 'ios-arrow-down-outline';
    //             if(data[i].reference_broker == "" || data[i].reference_broker == null || data[i].reference_broker == undefined){}else{
    //               var docRef1 = firebase.firestore().collection("users").doc(data[i].reference_broker);
    //               docRef1.get().then(function(doc) {
    //                 if (doc.exists) {
    //                   data[i].broker_name = doc.data().firstname+' '+doc.data().lastname;
    //                 } else {
    //                   console.log("No such document!");
    //                 }
    //               }).catch(function(error) {
    //                 console.log("Error getting document:", error);
    //               });
    //             }
    //           }
    //           thiss.loading.dismiss();
    //           thiss.data = data;
    //           thiss.contactTotal = data.length;
    //         });
    //       }
    //     }
    // }).catch(function(error) {
    //   console.log("Error getting document:", error);
    // });

  }

  ionViewWillEnter() {

    console.log('ion view will enter');
    this.menuCtrl.enable(true);
  }

  testuserkeyword() {
    this.afdService.generatekeyword().then((data:any = []) => {
      console.log(data);
    });
  }
  generateAdfkeyword() {
    this.afdService.generateAdfkeyword().then((data:any = []) => {
      console.log(data);
    });
  }
  gekeywordsemptyData() {
    console.log('abc');
    this.afdService.gekeywordsemptyData().then((data:any = []) => {
      console.log('keywords empty');
      console.log(data);
    });
  }

  // searchuser() {
  //   let search = 'abdul';
  //   this.afdService.searchuser(search).then((data:any = []) => {
  //     console.log(data);
  //   });
  // }

  // generatekeyword() {
  //   //const [first, middle, last, sfx] = names.first;
  //   const first = "Abdul";
  //   const last = "Sultan";
  //   const email = "abdul@sentientgeeks.com";
  //   const phone_number = "8910150447";
  //   const brokername = "john smith";
  //   //const suffix = sfx.length > 0 ? ` ${sfx}.` : '';
  //   const keywordNameWidthoutMiddleName = this.createKeywords(`${first} ${last}`);
  //   const keywordNameWithEmail = this.createKeywords(`${email}`);
  //   const keywordNameWithPhone = this.createKeywords(`${phone_number}`);
  //   const keywordNameWithBroker = this.createKeywords(`${brokername}`);
  //   console.log(keywordNameWidthoutMiddleName);
  //   console.log(keywordNameWithEmail);
  //   console.log(keywordNameWithPhone);
  //   console.log(keywordNameWithBroker);
  //   // const keywordFullName = this.createKeywords(`${first} ${middle} ${last}${suffix}`);
  //   // const keywordLastNameFirst = this.createKeywords(`${last}, ${first} ${middle}${suffix}`);

  //   // const middleInitial = middle.length > 0 ? ` ${middle[0]}.` : '';
  //   // const keywordFullNameMiddleInitial = this.createKeywords(`${first}${middleInitial} ${last}${suffix}`);
  //   // const keywordLastNameFirstMiddleInitial = this.createKeywords(`${last}, ${first}${middleInitial}${suffix}`);
  //   return [

  //   ];
  // }

  // createKeywords = name => {
  //   const arrName = [];
  //   let curName = '';
  //   name.split('').forEach(letter => {
  //     curName += letter;
  //     arrName.push(curName);
  //   });
  //   return arrName;
  // }

  getAllcontacts() {
    var limit = '';
    var offset= '';
    this.afdService.searchContactData().then((data:any = []) => {
      //console.log(data);
      this.allcontactlist = data;
    });
  }
  getAllAdflist() {
    this.afdService.getAllAdflist().then((data:any = []) => {
      //console.log(data);
      this.alldflist = data;
    });
  }
  // getAllAdfs() {
  //   var limit = '';
  //   var offset= '';
  //   this.afdService.getAllAdfsform().then((data:any) => {
  //     this.loadingstate =3;
  //     console.log(data);
  //     this.totalAdfs = data.length;
  //     //this.loading.dismiss();
  //   });
  // }

  addContact() {
    this.navCtrl.push(ContactList,{
      homepage:true
    });
  }
  addAdf() {
    this.navCtrl.push(AdfPage);
  }
  // getAllOpenAdf() {
  //   this.afdService.getAllOpenform().then((data:any) => {
  //    console.log('open adf');
  //     console.log(data);
  //     this.AllOpenAdfs = data;
  //     this.loadingstate =4;
  //   });
  // }
  // getAllCloseform() {
  //   this.afdService.getAllCloseform().then((data:any) => {
  //    console.log('close adf');
  //     this.AllCloseAdfs = data;
  //     this.loadingstate =5;

  //     this.loading.dismiss();
  //   });
  // }
  getDashboardData() {
    this.afdService.getDashboardData().then((data:any) => {
      console.log(data);
      this.AllOpenAdfs = data.allopenadf;
      this.AllCloseAdfs = data.allclosedadf;
      this.totalAdfs = data.totaladf;
      this.totalContacts = data.totalcontacts;
      this.loading.dismiss();
      console.log('dashboard data');

     });
  }
  presentLoadingText(){
    this.loading = this.loadingCtrl.create({
      content: 'Loading Please Wait...'
    });

    this.loading.present();
  }

  getBrokers (){
    if(this.getRole == 'super_admin'){
      return this.db.collection<any>( "users" , ref => ref.where('roles.contact','==',true )).valueChanges ();
    }else if(this.getRole == 'broker'){
      return this.db.collection<any>( "users" , ref => ref.where('roles.contact','==',true ).where('reference_broker','==',this.uid )).valueChanges ();
    }
  }


  getAllPosts (){
    if(this.getRole == 'super_admin'){
      if(this.deleted_access == 1){
        return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).orderBy('created_date', 'desc').limit(this.limit)).valueChanges ();
      }else{
        return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0).orderBy('created_date', 'desc').limit(this.limit)).valueChanges ();
      }
    }else if(this.getRole == 'broker'){
      return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('reference_broker','==',this.uid ).where('deleted','==',0).orderBy('created_date', 'desc').limit(this.limit)).valueChanges ();
    }else{
      //return [];
      var nav = this.app.getRootNav();
      nav.setRoot(ViewContactPage);
    }
  }

  getAllPostss (broker_uid){
    return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('reference_broker','==',broker_uid ).where('deleted','==',0).orderBy('created_date', 'desc').limit(this.limit)).valueChanges ();
  }

  getAllUsersWithPagination (endBefore:number){
    if(this.getRole == 'super_admin'){
      if(this.deleted_access == 1){
        return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges ();
      }else{
        return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('deleted','==',0).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges ();
      }
    }else if(this.getRole == 'broker'){
      return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('reference_broker','==',this.uid ).where('deleted','==',0).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges ();
    }
  }

  getAllUsersWithPaginations (broker_uid, endBefore:number){
    return this.db.collection<any>( "users" , ref => ref.where('created_date','>',0 ).where('roles.contact','==',true ).where('reference_broker','==',broker_uid ).where('deleted','==',0).orderBy('created_date', 'desc').limit(this.limit).startAfter(endBefore)).valueChanges ();
  }

  loadData(event, endBefore) {

    debugger;


  }
  onScroll(event) {
    let tracker = event.target;

    let limit = tracker.scrollHeight - tracker.clientHeight;
    console.log(event.target.scrollTop, limit);
    if (event.target.scrollTop === limit) {
      this.afdService.getallopenApplication().then((data)=>{
        console.log(data);
      })
    }
  }
  stringGen(len) {
    var text = "";
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));
    return text;
  }

  viewContact(event, contact_uid, SDF_form_document_id){
    this.navCtrl.push(ViewContactPage,{
      contact_uid:contact_uid,
      SDF_form_document_id:SDF_form_document_id
    });
  }

  restoreContact(event, SDF_form_document_id, document_id, contact_type, uid, index, index1){

    let alert = this.alertCtrl.create({
      title: 'Confirm restore contact',
      message: 'Are you sure you want to delete this restore?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  this.loadingProvider.startLoading();
                  let postData = {
                    'document_id': document_id,
                    'SDF_form_document_id': SDF_form_document_id,
                    'contact_type': contact_type,
                    'contact_uid' : uid
                  }
                  this.HomeService.restoreContact(postData)
                  .then((data) => {
                    if(data == 'success'){
                      this.data[index].user_data = [];
                      this.getUsers(uid).subscribe((data)=>{
                        if(data.length > 0){
                            data.forEach(uData => {
                              this.data[index].user_data.push(uData);
                            })
                        }
                      })
                    }else{
                      this.data[index].user_data = [];
                      this.getUsers(uid).subscribe((data)=>{
                        if(data.length > 0){
                            data.forEach(uData => {
                              this.data[index].user_data.push(uData);
                            })
                        }
                      })
                    }
                    this.presentToastSuccess('Restore successfully.');
                    this.loadingProvider.stopLoading();
                  }, (err) =>{

                  });
                }
              }
          }
      ]
    });
    alert.present();
  }

  deleteContact(event, SDF_form_document_id, document_id, contact_type, uid, index, index1){

    let alert = this.alertCtrl.create({
      title: 'Confirm delete contact',
      message: 'Are you sure you want to delete this contact?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(document_id !=""){
                  this.loadingProvider.startLoading();
                  let postData = {
                    'document_id': document_id,
                    'SDF_form_document_id': SDF_form_document_id,
                    'contact_type': contact_type,
                    'contact_uid' : uid,
                    'deleted_date': new Date().getTime()
                  }
                  this.HomeService.deleteContact(postData)
                  .then((data) => {
                    if(data == 'success'){
                      this.data[index].user_data = [];
                      this.getUsers(uid).subscribe((data)=>{
                        if(data.length > 0){
                            data.forEach(uData => {
                              this.data[index].user_data.push(uData);
                            })
                        }
                      })
                    }else{
                      this.data[index].user_data = [];
                      this.getUsers(uid).subscribe((data)=>{
                        if(data.length > 0){
                            data.forEach(uData => {
                              this.data[index].user_data.push(uData);
                            })
                        }
                      })
                    }
                    this.presentToastSuccess('Deleted successfully.');
                    this.loadingProvider.stopLoading();
                  }, (err) =>{

                  });
                  // if(this.data[index].user_data.length > 1){
                  //   this.data[index].user_data.splice((index1), 1);
                  // }else{
                  //   this.data[index].user_data = [];
                  // }

                }
              }
          }
      ]
    });
    alert.present();
  }

  getUsers(contact_uid){
    return this.db.collection<any>( "users_data", ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  permanentDeleteContact(event, contact_uid, secondary_contact_uid){

    let alert = this.alertCtrl.create({
      title: 'Confirm Permanently delete contact',
      message: 'Are you sure you want to Permanently delete this contact?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let secondary_contact_uid1 = '';
                  if(secondary_contact_uid != undefined){
                    secondary_contact_uid1 = secondary_contact_uid;
                  }
                  let postData = {
                    'contact_id' : contact_uid,
                    'secondary_contact_uid' : secondary_contact_uid1
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/permanentDeleteContacts";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToastSuccess('Deleted Permanently successfully.');
                      this.loadingProvider.stopLoading();
                    }else{
                      this.presentToastSuccess('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    console.log(error);
                    this.presentToast(error.message);
                  });
                }
              }
          }
      ]
    });
    alert.present();
  }

  changeAssignedBroker(event, contact_uid, SDF_form_document_id){
    let changeAssignedBroker = this.modalCtrl.create(ChangeAssignedBrokerPage, {
      "contact_uid": contact_uid,
      "SDF_form_document_id": SDF_form_document_id
    });

    changeAssignedBroker.present();
  }

  changeContactType(event, contact_uid){
    let changeContactType = this.modalCtrl.create(ChangeContactTypePopupPage, {
      "contact_uid": contact_uid
    });

    changeContactType.present();
  }

  popupAction(event: any, contact_uid: any, SDF_form_document_id: any, contact_type: any){
    let editMenu = this.popoverCtrl.create(EditPopoverPage, {contact_uid: contact_uid, view_contact: 'yes', SDF_form_document_id: SDF_form_document_id, contact_type: contact_type}, {showBackdrop: true, cssClass: 'popOverClass'});
    editMenu.present({
       ev: event // <-- the fix
    });

    editMenu.onDidDismiss(data =>{
      if(data == "" || data == null || data == undefined){}else{
        if(data.type == 'viewcontact'){
          let contact_uid = data.contact_uid;
          this.navCtrl.push(ViewContactPage,{
            contact_uid:contact_uid,
            SDF_form_document_id: SDF_form_document_id
          });
        }else if(data.type == 'editcontact'){
          let contact_uid = data.contact_uid;
          this.navCtrl.push(AdfPage,{
            edit_contact_uid:contact_uid,
            SDF_form_document_id: SDF_form_document_id
          });
        }else if(data.type == 'addsecondary'){
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("creating_second", 'yes');
          this.navCtrl.push(StepformPage);
        }else if(data.type == 'realestate'){
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("contact_second_uid", data.second_contact_id);
          this.navCtrl.push(RealEstatePage,{
            edit_contact_uid:data.contact_id_add_real_estate,
            second_contact_id : data.second_contact_id,
            SDF_form_document_id: SDF_form_document_id
          });
          window.localStorage.setItem("generate_new_tentative", '1');
        }else if(data.type == 'tentativerealestate'){
          window.localStorage.setItem("contact_uid", data.contact_id_add_real_estate);
          window.localStorage.setItem("contact_second_uid", data.second_contact_id);
          this.navCtrl.push(TentativeRealEstateAssetPage,{
            edit_contact_uid:data.contact_id_add_real_estate,
            second_contact_id : data.second_contact_id,
            SDF_form_document_id: SDF_form_document_id
          });
          window.localStorage.setItem("generate_new_tentative", '1');
        }else if(data.type == 'changelog'){
          let contact_uid = data.contact_uid;
          this.navCtrl.push(ChangeLogProfilePage,{
            contact_uid:contact_uid
          });
        }else if(data.type == 'syncMercury'){
          this.syncInMercury('', data.userData, '', data.userData.accessGrantedFromUser);
        }
      }
    });
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err.message,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  presentToastSuccess(success) {
    const toast = this.toastCtrl.create({
      message: success,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  syncInMercury(event, contact_data, reference_broker = '', accessGrantedFromUser = 0){
    let popUpTitle = 'Confirm Sync contact';
    let popUpDesc = 'Are you sure you want to sync contact with mercury?';
    let popUpCheckbox = [];
    if(accessGrantedFromUser != 1){
      popUpCheckbox = [{
        name: "name",
        type: "checkbox",
        label: "The contact details are not approved. Please confirm before continue."
      }];
      //this.presentToastSuccess('Contact not approved by user.');
    }

    this.assets_data = '';
    this.liabilities_data = '';
    this.realEstate_data = '';
    let alert = this.alertCtrl.create({
      title: popUpTitle,
      subTitle: popUpDesc,
      //message: popUpDesc,
      inputs: popUpCheckbox,
      cssClass: 'alertDanger',
      buttons: [
        {
            text: 'No',
            handler: () => {
                console.log('Cancel clicked');
            }
        },
        {
          text: 'Yes',
          handler: () => {
            if(accessGrantedFromUser != 1){
              if(alert.data.inputs[0].checked == false){
                alert.setMessage('Please confirm before continue.');
                return false;
              }
            }

            if(contact_data){
              this.loadingProvider.startLoading();

              this.getBrokerCredentail(contact_data.reference_broker).subscribe((broker_data)=>{
                if(broker_data.length > 0){
                  this.getEmployments(contact_data.uid).subscribe((employment_data)=>{
                    this.getAllAssets(contact_data.uid).subscribe((assets_data)=>{
                      this.assets_data = assets_data;
                    });
                    this.getAllLiabilities(contact_data.uid).subscribe((liabilities_data)=>{
                      this.liabilities_data = liabilities_data;
                    });

                    this.getAllrealEstate(contact_data.uid).subscribe((realEstate_data)=>{
                      this.realEstate_data = realEstate_data;
                    });

                    if(contact_data.secondary_contact_uid == "" || contact_data.secondary_contact_uid == null || contact_data.secondary_contact_uid == undefined){
                      this.second_contact_data = '';
                      this.second_employment_data = '';
                      this.second_income_data = '';
                      this.second_asset_data = '';
                      this.second_liabilities_data = '';
                    }else{
                      this.getContactDetails(contact_data.secondary_contact_uid).subscribe((second_contact_data)=>{
                        this.second_contact_data = second_contact_data;
                      });
                      this.getEmployments(contact_data.secondary_contact_uid).subscribe((second_employment_data)=>{
                        this.second_employment_data = second_employment_data;
                      });
                      this.getAllIncomes(contact_data.secondary_contact_uid).subscribe((second_income_data)=>{
                        this.second_income_data = second_income_data;
                      });
                      this.getAllAssets(contact_data.secondary_contact_uid).subscribe((second_asset_data)=>{
                        this.second_asset_data = second_asset_data;
                      });
                      this.getAllLiabilities(contact_data.secondary_contact_uid).subscribe((second_liabilities_data)=>{
                        this.second_liabilities_data = second_liabilities_data;
                      });
                    }

                    this.getAllIncomes(contact_data.uid).subscribe((income_data)=>{
                      var headers = new Headers();
                      headers.append("Accept", 'application/json');
                      headers.append('Content-Type', 'application/json' );
                      const requestOptions = new RequestOptions({ headers: headers });
                      let postData = {
                        'contact_data' : contact_data,
                        'employment_data' : employment_data[0],
                        'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                        'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                        'income_data' : income_data
                      }
                      var url = this.EnvDataService.EnvData.sendbox_api+"/mercurySyncContact";
                      this.http.post(url, postData, requestOptions)
                      .subscribe(getData => {
                        let responseData = JSON.parse(getData['_body']);
                        if(responseData.name != undefined){
                          this.loadingProvider.stopLoading();
                          this.presentToastSuccess('Something went wrong please try again later.');
                        }else{
                          if(this.second_contact_data.length > 0){
                            let secondPostData = {
                              'contact_data' : this.second_contact_data[0],
                              'employment_data' : this.second_employment_data[0],
                              'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                              'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                              'income_data' : this.second_income_data
                            }
                            var url = this.EnvDataService.EnvData.sendbox_api+"/mercurySyncContact";
                            this.http.post(url, secondPostData, requestOptions)
                            .subscribe(getSecondData => {
                              let responseSecondData = JSON.parse(getSecondData['_body']);
                              if(responseSecondData.name != undefined){
                                this.loadingProvider.stopLoading();
                                this.presentToastSuccess('Something went wrong please try again later.');
                              }else{
                                let oppurtunityData = {
                                  'contact_data' : contact_data,
                                  'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                                  'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                                  'uniqueId' : responseData.uniqueId,
                                  'assets_data' : this.assets_data,
                                  'liabilities_data' : this.liabilities_data,
                                  'second_uniqueId' : responseSecondData.uniqueId,
                                  'second_contact_data' : this.second_contact_data[0],
                                  'second_assets_data' : this.second_asset_data,
                                  'second_liabilities_data' : this.second_liabilities_data,
                                  'realEstate_data' : this.realEstate_data
                                }
                                var url = this.EnvDataService.EnvData.sendbox_api+"/mercurySyncCreateOportunity";
                                this.http.post(url, oppurtunityData, requestOptions)
                                .subscribe(getOData => {
                                  let responseOData = JSON.parse(getOData['_body']);
                                  if(responseOData.name != undefined){
                                    this.loadingProvider.stopLoading();
                                    this.presentToastSuccess('Oppurtunity not created.');
                                  }else{
                                    this.loadingProvider.stopLoading();
                                    this.presentToastSuccess('Contact sync successfully.');
                                    // if(this.realEstate_data.length > 0){
                                    //   let realestateData = {
                                    //     'contact_data' : contact_data,
                                    //     'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                                    //     'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                                    //     'uniqueId' : responseData.uniqueId,
                                    //     'opportunityId' : responseOData.uniqueId,
                                    //     'realEstate_data' : this.realEstate_data
                                    //   }
                                    //   this.http.post("https://us-central1-loan-management-sandbox.cloudfunctions.net/mercurySyncRealestate", realestateData, requestOptions)
                                    //   .subscribe(getRData => {
                                    //     let responseRData = JSON.parse(getRData['_body']);
                                    //     console.log(responseRData);
                                    //     if(responseRData.uniqueId == undefined || responseRData.uniqueId || null || responseRData.uniqueId == ""){
                                    //       this.loadingProvider.stopLoading();
                                    //       this.presentToastSuccess('Real Estate not created.');
                                    //     }else{
                                    //       this.loadingProvider.stopLoading();
                                    //       this.presentToastSuccess('Contact sync successfully.');
                                    //     }

                                    //   }, error => {
                                    //     this.loadingProvider.stopLoading();
                                    //     this.presentToast(error);
                                    //   });
                                    // }else{
                                    //   this.loadingProvider.stopLoading();
                                    //   this.presentToastSuccess('Contact sync successfully.');
                                    // }
                                  }
                                }, error => {
                                  this.loadingProvider.stopLoading();
                                  this.presentToast(error);
                                });
                              }
                            });

                          }else{
                            let oppurtunityData = {
                              'contact_data' : contact_data,
                              'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                              'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                              'uniqueId' : responseData.uniqueId,
                              'assets_data' : this.assets_data,
                              'liabilities_data' : this.liabilities_data,
                              'second_uniqueId' : undefined,
                              'second_contact_data' : undefined,
                              'realEstate_data' : this.realEstate_data
                            }
                             url = this.EnvDataService.EnvData.sendbox_api+"/mercurySyncCreateOportunity";
                            this.http.post(url, oppurtunityData, requestOptions)
                            .subscribe(getOData => {
                              let responseOData = JSON.parse(getOData['_body']);
                              if(responseOData.name != undefined){
                                this.loadingProvider.stopLoading();
                                this.presentToastSuccess('Oppurtunity not created.');
                              }else{
                                this.loadingProvider.stopLoading();
                                this.presentToastSuccess('Contact sync successfully.');
                                // if(this.realEstate_data.length > 0){
                                //   let realestateData = {
                                //     'contact_data' : contact_data,
                                //     'mercuryAgentCode' : broker_data[0].mercuryAgentCode,
                                //     'mercurySeurityToken' : broker_data[0].mercurySeurityToken,
                                //     'uniqueId' : responseData.uniqueId,
                                //     'opportunityId' : responseOData.uniqueId,
                                //     'realEstate_data' : this.realEstate_data
                                //   }
                                //   this.http.post("https://us-central1-loan-management-sandbox.cloudfunctions.net/mercurySyncRealestate", realestateData, requestOptions)
                                //   .subscribe(getRData => {
                                //     let responseRData = JSON.parse(getRData['_body']);
                                //     if(responseRData.uniqueId == undefined || responseRData.uniqueId || null || responseRData.uniqueId == ""){
                                //       this.loadingProvider.stopLoading();
                                //       this.presentToastSuccess('Real Estate not created.');
                                //     }else{
                                //       this.loadingProvider.stopLoading();
                                //       this.presentToastSuccess('Contact sync successfully.');
                                //     }

                                //   }, error => {
                                //     this.loadingProvider.stopLoading();
                                //     this.presentToast(error);
                                //   });
                                // }else{
                                //   this.loadingProvider.stopLoading();
                                //   this.presentToastSuccess('Contact sync successfully.');
                                // }
                              }
                            }, error => {
                              this.loadingProvider.stopLoading();
                              this.presentToast(error);
                            });
                          }
                        }
                      }, error => {
                        this.loadingProvider.stopLoading();
                        this.presentToast(error);
                      });
                    });
                  });
                }else{
                  this.loadingProvider.stopLoading();
                  this.presentToastSuccess('Broker not assigned.');
                }
              });
            }
          }
        }
      ]
    });
    alert.present();
    //}
  }

  getContactDetails(contact_uid){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0)).valueChanges();
  }

  getBrokerCredentail(contact_uid){
    return this.db.collection<any>( "brokerCredentials" , ref => ref.where('uid','==',contact_uid )).valueChanges ();
  }

  getEmployments(contact_uid){
    return this.db.collection<any>( "employment" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  getAllIncomes(contact_uid){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  getAllAssets(contact_uid){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  getAllLiabilities(contact_uid){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  getAllrealEstate(contact_uid){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('primary_uid','==',contact_uid ).where('deleted','==',0 )).valueChanges ();
  }

  getDetails(){

    //var Request = require("request");

    // Request.get({
    //     "headers": { "content-type": "application/json", 'x-api-key': 'H8ewTrp42H56XFzIepfDE6MwEEwO20416sn0lSbc' },
    //     "url": "https://apis.connective.com.au/mercury/v1/92798106-f583-4d82-9e37-146237c1118a/opportunities/aa25a7da-b3ab-11e9-8cca-0a9abd68703b/assets",
    // }, (error, response, body) => {
    //     if(error) {
    //         console.log(error);
    //     }
    //     console.log(JSON.parse(body));
    //     console.log(response);
    // });
  }

  clickToHomepage(){
    this.menuCtrl.close();
    var nav = this.app.getRootNav();
    //nav.setRoot(HomePage);
    nav.setRoot('AdminDashboardPage');
  }

  attachment_requests(event, contact_uid, reference_broker){
    let attachmentRequests = this.modalCtrl.create(AttachmentRequestsPage, {
      "contact_uid": contact_uid,
      "reference_broker": reference_broker
    });
    attachmentRequests.present();
  }

  getIncomeByContactID (contact_uid){
    return this.db.collection<any>( "SDF_income" , ref => ref.where('uid','==',contact_uid ).where('deleted','<',1)).valueChanges ();
  }
  getAssetsByContactID (contact_uid){
    return this.db.collection<any>( "SDF_assets" , ref => ref.where('uid','==',contact_uid ).where('deleted','<',1)).valueChanges ();
  }
  getLiabilitiesByContactID (contact_uid){
    return this.db.collection<any>( "SDF_liabilities" , ref => ref.where('uid','==',contact_uid ).where('deleted','<',1)).valueChanges ();
  }
  getRealEstateByContactID (contact_uid){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('primary_uid','==',contact_uid ).where('deleted','<',1)).valueChanges ();
  }

  getSDFFormByID (contact_uid){
    debugger;
    if(this.getRole == 'super_admin'){
      if(this.deleted_access == 1){
        return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',contact_uid )).valueChanges ();
      }else{
        return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',contact_uid ).where('deleted','<',1)).valueChanges ();
      }
    }else{
      return this.db.collection<any>( "users_data" , ref => ref.where('uid','==',contact_uid ).where('deleted','<',1)).valueChanges ();
    }
  }

  getUserDataByID (id, uid){
    return this.db.collection<any>( "users_data" , ref => ref.where('SDF_form_document_id','==',id ).where('uid','==',uid ).where('deleted','<',1)).valueChanges ();
  }

  typeOf(value) {
    return typeof value;
  }

  getTotalSDFForms(event, uid, index, total_Records){

    if(this.haveClickedview == true){
      return;
    }
    if(this.haveClickedview == undefined || this.haveClickedview == null){
      this.haveClickedview = true;
    }

    let index1 = index+1;
    let data = [];
    this.haveRecord = [{"count_secondary": null}];
    let total_Record = 0;
    let thiss = this;
    if(total_Records > 0){
      this.data[index].icon = 'ios-arrow-down-outline';
      this.data[index].total_Record = 0;
      // for(let i = 0; i < total_Records; i++){
      //   this.data.splice((index1), 1);
      // }
      this.data.splice((index1), 1);
      this.haveClickedview = null;
    }else{
      this.data[index].icon = 'ios-arrow-up-outline';
      this.getSDFFormByID(uid).subscribe((SDFData)=>{
        console.log('uid',uid)
        debugger
        if(SDFData.length > 0){
          this.haveRecord = SDFData;
          Object.keys(SDFData).forEach(function(key) {
            SDFData[key]['count_secondary'] = SDFData.length ;
            data.push(SDFData[key]);
            total_Record += 1;
            thiss.data[index].total_Record = total_Record;
            var docRef = firebase.firestore().collection("users").doc(SDFData[key].reference_broker);
            docRef.get().then(function(doc) {
              if (doc.exists) {
                let broker_data = doc.data();
                data[key].broker_name = broker_data.firstname+' '+broker_data.lastname;
              }
            });
            thiss.getPrimaryContactBySDFID(SDFData[key].SDF_form_document_id).subscribe((PrimaryContact)=>{
              if(PrimaryContact.length > 0){
                data[key].firstname = PrimaryContact[0].firstname;
                data[key].lastname = PrimaryContact[0].lastname;
                data[key].middlename = PrimaryContact[0].middlename;
              }
            });
          });
        }else{
          total_Record += 1;
          thiss.data[index].total_Record = total_Record;
          data = [{'count_secondary': SDFData.length}]
          this.haveRecord = {'count_secondary': SDFData.length};
          this.data[index1].user_data = data;
        }
        this.haveClickedview = null;
      });
      this.data.splice(index1, 0, {'inner_data':1});
      this.data[index1].user_data = data;
      this.data[index].total_Record = total_Record;
      //data = [];
    }
    //this.data[index1].inner_data = 1;
    //let data1 = {'firstname': 'test', 'inner_data': 1, 'data_count': 2, 'lastname': 'testt', 'email': 'testestteestse@test.tse', 'mobile_phone': '6547821450', 'contact_type': 'Secondary Contact', 'broker_name': 'Kathy Harvey'}
    //this.data[1].user_data =
    //this.data.splice(3, 0, data1);
  }

  searchcontact(event) {
    console.log(event);
    //debugger;
   let searchkey =  event.value;
    if(searchkey !== '') {
      this.contactkey = true;
      //console.log(this.allcontactlist);
        //this.filterdata(searchkey)
        //console.log(this.allcontactlist);
        this.afdService.searchAllContacts(searchkey).then((data:any = []) => {
          this.contactdata = data;
        });
    }
    else {
      this.contactkey = false;
      this.contactdata = [];

    }
  }
  searchadf(event) {
    let searchkey =  event.value;
    if(searchkey !== '') {
        this.adfkey = true;
        //this.filteradfdata(searchkey)
        this.afdService.searchAllAdfs(searchkey).then((data:any = []) => {
          this.adfdata = data;
        });
    }
    else {
      this.adfkey = false;
      this.adfdata = [];
    }
  }
  filterdata(searchkey) {
    this.contactdata = [];

    this.allcontactlist.forEach(element => {
      if(element.firstname.toLowerCase() == searchkey.toLowerCase() ||
      element.lastname.toLowerCase() == searchkey.toLowerCase() ||
      element.email.toLowerCase() == searchkey.toLowerCase()) {
        if(element) {
         this.savecontactdata(element);
        }
      }
      if(element.firstname.toLowerCase().includes(searchkey.toLowerCase())||
      element.lastname.toLowerCase().includes(searchkey.toLowerCase())||
      element.email.toLowerCase().includes(searchkey.toLowerCase())) {
        if(element) {
          this.savecontactdata(element);
        }
      }
    })

  }

  filteradfdata(searchkey) {

    this.adfdata = [];
    this.alldflist.forEach(element => {
      if(element.title.toLowerCase() == searchkey.toLowerCase()) {
        if(element) {
          this.savecadfdata(element);

        }
      }
      if(element.title.toLowerCase().includes(searchkey.toLowerCase())) {
        if(element) {
          this.savecadfdata(element);
        }
      }
    })
    // this.adfdata = filterdata;
  }

  savecadfdata(adfdata) {
    const isElementPresent = this.adfdata.some((o) => o.adf_form_id === adfdata.adf_form_id);
      if (!isElementPresent) {
        this.adfdata.push(adfdata);
    }
  }

  savecontactdata(userdata) {


    const isElementPresent = this.contactdata.some((o) => o.email === userdata.email);
      if (!isElementPresent) {
        this.contactdata.push(userdata);
    }
  }

  viewContactData(event, contact_uid){

    this.navCtrl.push(ShowContactForm,{
      contact_uid:contact_uid,
      });
  }
  viewAdfData(event,adf_id,user_id){
    debugger;
    this.navCtrl.push(ViewAdfPage,{
      contact_uid:user_id,
      SDF_form_document_id:adf_id,
    });
  }

  viewContactList() {
    //ContactList
    this.navCtrl.push(ContactList);
  }
  viewAdfList() {
    //ContactList
    this.navCtrl.push(AdfList);
  }

  getPrimaryContactBySDFID (SDF_form_document_id){
    return this.db.collection<any>( "users_data" , ref => ref.where('SDF_form_document_id','==',SDF_form_document_id ).where('contact_type','==','Primary Contact' ).where('deleted','<',1)).valueChanges ();
  }


}



// WEBPACK FOOTER //
// ./src/pages/admin-dashboard/admin-dashboard.ts